import * as dayjs from "dayjs";
import * as utcPlugin from "dayjs/plugin/utc";
import * as timezonePlugin from "dayjs/plugin/timezone";
import * as relativeTimePlugin from "dayjs/plugin/relativeTime";
import * as localizedFormatPlugin from "dayjs/plugin/localizedFormat";
import * as customParseFormatPlugin from "dayjs/plugin/customParseFormat";
import * as advancedFormatPlugin from "dayjs/plugin/advancedFormat";

import * as durationPlugin from 'dayjs/plugin/duration';
dayjs.extend(utcPlugin);
dayjs.extend(timezonePlugin);
dayjs.extend(relativeTimePlugin);
dayjs.extend(localizedFormatPlugin);
dayjs.extend(advancedFormatPlugin);
dayjs.extend(customParseFormatPlugin);
dayjs.extend(durationPlugin);

export const DateUtils = {

  formatTimeWithZone: ( time: any, timeZone: string = "Asia/Kolkata", format: string = 'HH:mm'): string => {
    return time && dayjs(time).isValid() ? dayjs(time).tz(timeZone).format(format) : '--';//time should not equals to 0,null,undefined,false
  },
  parseToTimeZone: (time: any, timeZone: string = "Asia/Kolkata") => {
    return time && dayjs(time).isValid() ? dayjs(time).tz(timeZone) : '--';
  },
  formatTime: (time: any, format: string = 'HH:mm'): string => {
   return time && dayjs(time).isValid() ? dayjs(time).format(format) : '--';
  },

  formatDate: (date: any, format: string = 'DD/MM/YYYY'): string => {
    return dayjs(date).format(format);
  },
  formatDateTime: (dateTime: any, format = 'hh:mm'): string => {
    return dayjs(dateTime).isValid() ? dayjs(dateTime).format(format) : '--';
  },

  customFormatDate: ( date: string,inputFormat: string,outputFormat: string = 'DD/MM/YYYY' ): string => {
    return dayjs(date, inputFormat).format(outputFormat);
  },

  parseDateString: (timeString: string, inputFormat: string) => {
    return dayjs(timeString, inputFormat);
  },
  formatCurrentDate : (format:string) => {
    return dayjs().format(format);
  },
  

  subtractDays: (date: any, days: number = 1, format: string ): string => {
    return dayjs(date).subtract(days, 'days').format(format);
  },

  convertMinutesToHours: (minutes: string | number): number => {
    const minutesNumber = typeof minutes === 'string' ? parseFloat(minutes) : minutes;
    return dayjs.duration(minutesNumber, 'minutes').asHours();
  },
  convertMillisecondsToHours: (milliseconds: string | number): number => {
    const millisecondsNumber = typeof milliseconds === 'string' ? parseFloat(milliseconds) : milliseconds;
    return dayjs.duration(millisecondsNumber, 'milliseconds').asHours();
  },
  getMinutesFromDuration: (minutes: string | number): number => { //retrieves the minute part of the duration - if it is 1 hour 30 mins , it will return the 30 mins 
    const minutesNumber = typeof minutes === 'string' ? parseFloat(minutes) : minutes;
    return dayjs.duration(minutesNumber, 'minutes').minutes();
  },
  getMinutesFromMilliseconds: (milliseconds: string | number): number => {
    const millisecondsNumber = typeof milliseconds === 'string' ? parseFloat(milliseconds) : milliseconds;
    return dayjs.duration(millisecondsNumber, 'milliseconds').minutes();
  },
  formatEpochToTime: (epoch: any, format: string = 'HH:mm'): string => {
    return epoch ? dayjs(epoch).format(format) : "--";
  },


};